import React from "react";

import {
  EyeOpenIcon,
  NewThreadIcon,
  NotebookViewIcon,
} from "../icons/CustomIcons";

/** Stable view ids for plain-code project shell tabs (do not rename). */
export const TAO_PROJECT_VIEW = {
  chat: "chat",
  code: "code",
  preview: "preview",
} as const;

export type TaoProjectView =
  (typeof TAO_PROJECT_VIEW)[keyof typeof TAO_PROJECT_VIEW];

export type TaoProjectViewDefinition = {
  readonly id: TaoProjectView;
  readonly label: string;
  readonly icon: React.ReactElement;
};

export const TAO_PROJECT_VIEW_DEFINITIONS: ReadonlyArray<TaoProjectViewDefinition> =
  [
    {
      id: TAO_PROJECT_VIEW.chat,
      label: "Agent",
      icon: <NewThreadIcon />,
    },
    {
      id: TAO_PROJECT_VIEW.code,
      label: "Code",
      icon: <NotebookViewIcon />,
    },
    {
      id: TAO_PROJECT_VIEW.preview,
      label: "Preview",
      icon: <EyeOpenIcon />,
    },
  ];

/** Explorer seats never author code by hand, so they get Agent and Preview only on every Tao project. */
export function restrictTaoProjectViewsForExplorer({
  availableViews,
  isExplorer,
}: {
  availableViews: ReadonlyArray<TaoProjectViewDefinition>;
  isExplorer: boolean;
}): ReadonlyArray<TaoProjectViewDefinition> {
  if (!isExplorer) {
    return availableViews;
  }
  return availableViews.filter((view) => view.id !== TAO_PROJECT_VIEW.code);
}

/** Max content width for the Chat tab agent UI (matches logic-view fullscreen threads). */
export const TAO_PROJECT_FULLSCREEN_CHAT_CONTENT_MAX_WIDTH = 760;
